module.exports = "/virtual-football-league/img/amblems/right/logos/FakeNorwichCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/FakeNorwichCity.png
// module id = 2176
// module chunks = 4